import React, { useEffect, useState } from "react";
import { ArrowLeft, ExternalLink, Trash2 } from "lucide-react";
import { zonedTimeToUtc, utcToZonedTime } from "date-fns-tz";
import { format } from "date-fns";
import Select from "react-select";
//
import LogoUpload from "./LogoUpload";
//
import { useParams } from "react-router";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import {
  PULL_ORGANIZATION,
  UPDATE_ORGANIZATION,
  SG_GET_SURVEY_STRUCTURES,
  UPDATE_EMPLOYEE_PAGE_NUMBER,
  SG_GET_SURVEY_QUESTION_SELECT,
  SG_GET_ALL_SURVEY_QUESTION_SELECT,
  SG_GET_ORGANIZATION_STYLE,
} from "constants/actions";
//
import {
  RowEditList,
  RowObjectInputEdit,
  RulesSubList,
  SurveySequenceList,
  OrgCategoryObjectInputEdit,
} from "./Components";
//
import AccountList from "account/List";
import EmployeeList from "employees/List";
import ManagerList from "employees/Managers";
import CategoryRowCard from "categories/List/RowCard";
//
import UpdateOrg from "./UpdateOrg";
//
import { SUB_DOMAIN_NAMES, ORG_PAID_STATUS } from "data/AdminData";
import { CommonTimezones } from "data/timezone";
import CategoryQuestions from "./CategoryQuestions";
// shadcn/ui
import { Button } from "components/ui/button";
import { Alert, AlertDescription, AlertTitle } from "components/ui/alert";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "components/ui/dialog";
import { Card as UiCard, CardContent as UiCardContent, CardHeader as UiCardHeader, CardTitle as UiCardTitle, CardDescription as UiCardDescription } from "components/ui/card";
import { Separator } from "components/ui/separator";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "components/ui/tabs";
//
const Details = ({ setShowHeaderTxt }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const [openOrgEdit, setOpenOrgEdit] = React.useState(false);

  const [organizationId, setOrganizationId] = useState(null);
  const [organizationDetails, setOrganizationDetails] = useState(null);
  const [organizationStylingSelect, setOrganizationStylingSelect] = useState(
    []
  );
  const [orgStyleSelected, setOrgStyleSelected] = useState([]);
  const [domainSelected, setDomainSelected] = useState(null);
  const [paymentStatusSelected, setPaymentStatusSelected] = useState(null);
  const [serviceList, setServiceList] = useState([]);
  const [updateValue, setUpdateValue] = useState(false);
  const [stylingList, setStylingList] = useState([]);

  const [orgIndustryCategory, setOrgIndustryCategory] = useState([]);
  const [updateIndustryValue, setUpdateIndustryValue] = useState(false);

  const [stylingMsg, setStylingMsg] = useState(false);
  const [timeZone, setTimeZone] = useState({
    value: "America/Halifax",
    label: "America/Halifax",
    text: "America/Halifax",
  });

  const [results, setResults] = useState([]);

  function BackArrow() {
    navigate("/app/organizations");
  }

  useEffect(() => {
    setOrganizationId(id);
  }, [id]);

  useEffect(() => {
    setShowHeaderTxt(false);
  }, [setShowHeaderTxt]);

  const utcDateTime = utcToZonedTime(new Date(), "UTC");
  const [localDateTime, setLocalDateTime] = useState(
    zonedTimeToUtc(new Date(), "America/Halifax")
  );

  useEffect(() => {
    if (organizationDetails?.time_zone) {
      const date = new Date();
      const timeZone = organizationDetails?.time_zone;
      const zonedDate = utcToZonedTime(date, timeZone);
      // const pattern = 'dd.MMM.yyyy HH:mm XXX (z)'
      // const output = format(zonedDate, pattern)
      setLocalDateTime(zonedDate);
    }
  }, [organizationDetails]);

  useEffect(() => {
    if (organizationId) {
      dispatch({
        type: PULL_ORGANIZATION,
        payload: { id: organizationId },
      });
      dispatch({
        type: SG_GET_SURVEY_QUESTION_SELECT,
      });
      dispatch({
        type: SG_GET_ALL_SURVEY_QUESTION_SELECT,
      });
      dispatch({
        type: UPDATE_EMPLOYEE_PAGE_NUMBER,
        payload: 1,
      });
      dispatch({
        type: SG_GET_SURVEY_STRUCTURES,
        payload: `organization=${organizationId}`,
      });
    }
  }, [dispatch, organizationId]);

  useEffect(() => {
    if (organizationId) {
      dispatch({
        type: SG_GET_ORGANIZATION_STYLE,
      });
    }
  }, [dispatch, organizationId, stylingMsg]);

  const {
    get_organizations,
    get_survey_question_select,
    get_survey_question_all_select,
    get_survey_structure,
  } = useSelector(
    (state) => ({
      get_organizations: state.organizations,
      get_survey_question_select: state.surveyquestion.survey_question_select,
      get_survey_question_all_select:
        state.surveyquestion.survey_question_all_select,
      get_survey_structure: state.surveystructure.survey_structure,
    }),
    shallowEqual
  );

  useEffect(() => {
    setOrganizationDetails(get_organizations?.[organizationId]);
    setServiceList(get_organizations?.[organizationId]?.services_enabled);
    setStylingList(get_organizations?.[organizationId]?.styling);
    setOrganizationStylingSelect(get_organizations?.organization_style);
    setOrgIndustryCategory(get_organizations?.[organizationId]?.org_category);
  }, [get_organizations, organizationId]);

  useEffect(() => {
    setResults(get_survey_structure?.results);
  }, [get_survey_structure]);

  function UpdateDetails() {
    setUpdateValue(false);
    if (organizationId) {
      dispatch({
        type: UPDATE_ORGANIZATION,
        payload: {
          id: organizationId,
          services_enabled: serviceList,
          styling: stylingList,
        },
      });
    }
  }

  function UpdateIndustryCategoryValues() {
    if (organizationId) {
      dispatch({
        type: UPDATE_ORGANIZATION,
        payload: {
          id: organizationId,
          org_category: orgIndustryCategory,
        },
      });
      setStylingMsg({
        header: "Category Changed",
        content: JSON.stringify(orgIndustryCategory),
      });
    }
  }

  useEffect(() => {
    setDomainSelected(
      SUB_DOMAIN_NAMES.filter(
        (sd) => sd.value === organizationDetails?.sub_domain
      )?.[0]
    );
    setPaymentStatusSelected(
      ORG_PAID_STATUS.filter(
        (sd) => sd.value === organizationDetails?.payment_status
      )?.[0]
    );
    setTimeZone(
      CommonTimezones.filter(
        (sd) => sd.value === organizationDetails?.time_zone
      )?.[0]
    );
  }, [organizationDetails]);

  function UpdateDomain() {
    if (organizationId) {
      dispatch({
        type: UPDATE_ORGANIZATION,
        payload: {
          id: organizationId,
          sub_domain: domainSelected?.value,
          payment_status: paymentStatusSelected?.value,
          time_zone: timeZone.value,
        },
      });
    }
  }

  function ReplaceStyling(e) {
    // console.log(e?.id)
    // console.log(e?.styling)
    setStylingMsg(false);
    setStylingList(false);
    setOrgStyleSelected(e);
    if (e?.styling) {
      setStylingList(e?.styling);
    } else {
      setStylingList(false);
    }
  }

  function UpdateCurrentStyling() {
    if (organizationId) {
      dispatch({
        type: UPDATE_ORGANIZATION,
        payload: {
          id: organizationId,
          styling: stylingList,
        },
      });
      setStylingMsg({
        header: "Styling Changed",
        content: JSON.stringify(stylingList),
      });
    }
  }

  function DeleteRules() {
    let _newList = stylingList;
    delete _newList["rules"];

    if (organizationId) {
      dispatch({
        type: UPDATE_ORGANIZATION,
        payload: {
          id: organizationId,
          styling: stylingList,
        },
      });
      setStylingMsg({
        header: "Rules Deleted",
        content: "Existing rules have been deleted",
      });
    }
  }

  function EditOrgName() {
    if (organizationDetails?.id) {
      setOpenOrgEdit(true);
    }
  }

  return (
    <>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Button variant="ghost" size="sm" onClick={BackArrow}>
            <ArrowLeft className="h-4 w-4 mr-1" /> Back
          </Button>
          {organizationDetails?.logo && (
            <img alt="Organization logo" src={organizationDetails?.logo} className="h-8 w-8 rounded object-contain" />
          )}
          <div className="text-lg font-semibold truncate">{organizationDetails?.name || "Organization"}</div>
        </div>
        <div className="flex items-center gap-2">
          <Button variant="outline" size="sm" onClick={() => navigate(`/app/organizations/details/${organizationId}`)}>Overview</Button>
          <Button variant="default" size="sm" onClick={() => navigate(`/app/organizations/details/${organizationId}/onboarding/emails`)}>Survey Tokens</Button>
        </div>
      </div>

      <Separator className="my-3" />

      <div className="space-y-6">
        {stylingMsg && (
          <Alert>
            <AlertTitle>{stylingMsg.header}</AlertTitle>
            <AlertDescription>{stylingMsg.content}</AlertDescription>
          </Alert>
        )}

        <Tabs defaultValue="survey-config" className="w-full">
          <TabsList>
            <TabsTrigger value="survey-config">Survey Config</TabsTrigger>
            <TabsTrigger value="org-settings">Org Settings</TabsTrigger>
            <TabsTrigger value="brand">Brand</TabsTrigger>
            <TabsTrigger value="org-overview">Org Overview</TabsTrigger>
            <TabsTrigger value="org-category">Org Category</TabsTrigger>
            <TabsTrigger value="survey-questions">Survey Questions</TabsTrigger>
            <TabsTrigger value="survey-structure">Survey Structure</TabsTrigger>
            <TabsTrigger value="accounts">Accounts</TabsTrigger>
            <TabsTrigger value="managers">Managers</TabsTrigger>
            <TabsTrigger value="employees">Employees</TabsTrigger>
            <TabsTrigger value="survey-scheduled">Survey Scheduled</TabsTrigger>
          </TabsList>

          <TabsContent value="survey-config">
            <UiCard>
              <UiCardHeader>
                <UiCardTitle>Survey Configuration</UiCardTitle>
                <UiCardDescription>Manage services, styling, sequences, and rules for surveys.</UiCardDescription>
              </UiCardHeader>
              <UiCardContent className="space-y-8">
                <section id="services" className="space-y-3">
                  <div>
                    <h3 className="text-base font-semibold">Services Enabled</h3>
                    <p className="text-sm text-muted-foreground">Manage which services are active for this organization.</p>
                  </div>
                  <div className="w-full overflow-x-auto">
                    <RowEditList
                      serviceList={serviceList}
                      setServiceList={setServiceList}
                      setUpdateValue={setUpdateValue}
                      get_survey_question_select={get_survey_question_select}
                    />
                  </div>
                  <Button onClick={UpdateDetails} disabled={!updateValue}>Update</Button>
                </section>

                <Separator />

                <section id="styling" className="space-y-3">
                  <div>
                    <h3 className="text-base font-semibold">Styling</h3>
                    <p className="text-sm text-muted-foreground">Control the visual styling applied to surveys and communications.</p>
                  </div>
                  <div className="flex flex-wrap gap-4 py-2">
                    <div className="min-w-[300px]">
                      <label className="mb-1 block text-sm font-medium">Select An Existing Styling</label>
                      <Select
                        name="OrganizationStyling"
                        options={organizationStylingSelect}
                        isClearable
                        onChange={ReplaceStyling}
                        value={orgStyleSelected}
                        getOptionLabel={(answers) => answers.name}
                        getOptionValue={(answers) => answers.id}
                      />
                    </div>
                    <div className="min-w-[160px] pb-1">
                      <Button
                        disabled={orgStyleSelected ? !Object.values(orgStyleSelected).length > 0 : true}
                        className="mt-5"
                        onClick={UpdateCurrentStyling}
                      >
                        Replace Styling
                      </Button>
                    </div>
                  </div>
                  <RowObjectInputEdit
                    stylingList={stylingList}
                    setStylingList={setStylingList}
                    setUpdateValue={setUpdateValue}
                  />
                  <Button onClick={UpdateDetails} disabled={!updateValue}>Update</Button>
                </section>

                <Separator />

                <section id="survey-sequence" className="space-y-3">
                  <div>
                    <h3 className="text-base font-semibold">Survey Sequence</h3>
                    <p className="text-sm text-muted-foreground">Configure the components and their order for survey delivery.</p>
                  </div>
                  <div className="w-full overflow-x-auto">
                    <SurveySequenceList
                      stylingList={stylingList}
                      setStylingList={setStylingList}
                      setUpdateValue={setUpdateValue}
                      get_survey_question_all_select={get_survey_question_all_select}
                    />
                  </div>
                  {stylingList?.survey_sequence && (
                    <Button onClick={UpdateDetails} disabled={!updateValue}>Update</Button>
                  )}
                </section>

                <Separator />

                <section id="rules" className="space-y-3">
                  <div className="flex items-start justify-between gap-4">
                    <div>
                      <h3 className="text-base font-semibold">Rules for Survey</h3>
                      <p className="text-sm text-muted-foreground">Define follow-up logic for high or low scores.</p>
                    </div>
                    {stylingList?.rules && (
                      <Button variant="ghost" size="icon" onClick={DeleteRules} aria-label="Delete rules">
                        <Trash2 className="h-4 w-4" />
                      </Button>
                    )}
                  </div>
                  <RulesSubList
                    stylingList={stylingList}
                    setStylingList={setStylingList}
                    setUpdateValue={setUpdateValue}
                  />
                  {stylingList?.rules && (
                    <Button onClick={UpdateDetails} disabled={!updateValue}>Update</Button>
                  )}
                </section>
              </UiCardContent>
            </UiCard>
          </TabsContent>

          <TabsContent value="org-settings">
            <UiCard>
              <UiCardHeader>
                <UiCardTitle>Organization Settings</UiCardTitle>
                <UiCardDescription>Paid status, domain and time zone</UiCardDescription>
              </UiCardHeader>
              <UiCardContent className="space-y-4">
                <div className="z-[5]">
                  <label className="mb-1 block text-sm font-medium">Paid Status</label>
                  <Select name="payment_status" options={ORG_PAID_STATUS} isClearable onChange={setPaymentStatusSelected} value={paymentStatusSelected} />
                </div>
                <div className="z-[5]">
                  <label className="mb-1 block text-sm font-medium">Set Domain</label>
                  <Select name="domain" options={SUB_DOMAIN_NAMES} isClearable onChange={setDomainSelected} value={domainSelected} />
                </div>
                <div className="z-[5]">
                  <label className="mb-1 block text-sm font-medium">Set Time zone</label>
                  <Select name="timezone" options={CommonTimezones} isClearable onChange={setTimeZone} value={timeZone} />
                </div>
                <div>
                  <Button onClick={UpdateDomain}>Update</Button>
                </div>
              </UiCardContent>
            </UiCard>
          </TabsContent>

          <TabsContent value="brand">
            <UiCard>
              <UiCardHeader>
                <UiCardTitle>Brand</UiCardTitle>
                <UiCardDescription>Upload or replace organization logo</UiCardDescription>
              </UiCardHeader>
              <UiCardContent>
                <LogoUpload organization={organizationDetails} />
              </UiCardContent>
            </UiCard>
          </TabsContent>

          <TabsContent value="org-overview">
            <UiCard>
              <UiCardHeader>
                <UiCardTitle>Organization Overview</UiCardTitle>
                <UiCardDescription>Key details at a glance</UiCardDescription>
              </UiCardHeader>
              <UiCardContent className="space-y-3 text-sm">
                <div>
                  <div className="text-muted-foreground">Created</div>
                  <div className="font-medium">
                    {organizationDetails?.created_at &&
                      format(new Date(organizationDetails?.created_at), "dd-MMM-yyyy")}
                  </div>
                </div>
                <div>
                  <div className="text-muted-foreground">Domain</div>
                  <div className="font-medium">{organizationDetails?.sub_domain_text}</div>
                </div>
                <div>
                  <div className="text-muted-foreground">UTC Time</div>
                  <div className="font-medium">{format(utcDateTime, "dd-MMM-yyyy hh:mm")}</div>
                </div>
                <div>
                  <div className="text-muted-foreground">Local Time</div>
                  <div className="font-medium">{localDateTime && format(localDateTime, "dd-MMM-yyyy hh:mm XXX (z)")}</div>
                </div>
                <div>
                  <div className="text-muted-foreground">User Timezone</div>
                  <div className="font-medium">{organizationDetails?.time_zone}</div>
                </div>
                <div className="pt-2">
                  <Button variant="outline" size="sm" onClick={EditOrgName}>
                    <ExternalLink className="h-4 w-4 mr-1" /> Edit Organization
                  </Button>
                </div>
              </UiCardContent>
            </UiCard>
          </TabsContent>

          <TabsContent value="org-category">
            <UiCard>
              <UiCardHeader>
                <UiCardTitle>Organization Category</UiCardTitle>
                <UiCardDescription>Classify information based on the business category</UiCardDescription>
              </UiCardHeader>
              <UiCardContent className="space-y-3">
                <OrgCategoryObjectInputEdit
                  stylingList={orgIndustryCategory}
                  setStylingList={setOrgIndustryCategory}
                  setUpdateValue={setUpdateIndustryValue}
                />
                <Button onClick={UpdateIndustryCategoryValues} disabled={!updateIndustryValue}>Update</Button>
              </UiCardContent>
            </UiCard>
          </TabsContent>

          <TabsContent value="survey-questions">
            <UiCard>
              <UiCardHeader>
                <UiCardTitle>Survey Questions</UiCardTitle>
                <UiCardDescription>List of questions for any given survey</UiCardDescription>
              </UiCardHeader>
              <UiCardContent className="space-y-4">
                <CategoryQuestions />
              </UiCardContent>
            </UiCard>
          </TabsContent>

          <TabsContent value="survey-structure">
            <UiCard>
              <UiCardHeader>
                <UiCardTitle>Survey Structure (Categories)</UiCardTitle>
                <UiCardDescription>Your Categories would appear below</UiCardDescription>
              </UiCardHeader>
              <UiCardContent>
                <div id="survey-structure" className="grid grid-cols-1 gap-3 md:grid-cols-2 lg:grid-cols-3">
                  {results && results.map((result) => (
                    <CategoryRowCard row={result} key={result?.id} />
                  ))}
                </div>
              </UiCardContent>
            </UiCard>
          </TabsContent>

          <TabsContent value="accounts">
            <UiCard>
              <UiCardHeader>
                <UiCardTitle>Login Accounts</UiCardTitle>
              </UiCardHeader>
              <UiCardContent>
                <AccountList orgId={organizationId} />
              </UiCardContent>
            </UiCard>
          </TabsContent>

          <TabsContent value="managers">
            <UiCard>
              <UiCardHeader>
                <UiCardTitle>Managers</UiCardTitle>
              </UiCardHeader>
              <UiCardContent>
                <ManagerList hideOrgSelect={true} pageNo={1} orgId={organizationId} />
              </UiCardContent>
            </UiCard>
          </TabsContent>

          <TabsContent value="employees">
            <UiCard>
              <UiCardHeader>
                <UiCardTitle>Employees</UiCardTitle>
              </UiCardHeader>
              <UiCardContent>
                <EmployeeList hideOrgSelect={true} pageNo={1} orgId={organizationId} />
              </UiCardContent>
            </UiCard>
          </TabsContent>

          <TabsContent value="survey-scheduled">
            <UiCard>
              <UiCardHeader>
                <UiCardTitle>Survey Scheduled</UiCardTitle>
                <UiCardDescription>Your Survey's Scheduled would appear below</UiCardDescription>
              </UiCardHeader>
              <UiCardContent>
                <p className="text-sm text-muted-foreground">Your survey schedule details will appear here.</p>
              </UiCardContent>
            </UiCard>
          </TabsContent>
        </Tabs>
      </div>

      <Dialog open={openOrgEdit} onOpenChange={setOpenOrgEdit}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Update Org Details</DialogTitle>
            <DialogDescription />
          </DialogHeader>
          <UpdateOrg
            organizationDetails={organizationDetails}
            setOpenOrgEdit={setOpenOrgEdit}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default Details;

